import * as types from "./types";
import { requestAuth } from "../helpers/FetchApi";
import { ActionsCreators } from "../actions";
import appSettings from "../AppSettings";
import { toast } from "react-toastify";
import strings from "../helpers/Localization";

export const actionCreators = {
    GetStyles: (pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess, secondary) => async (dispatch, store) => {

        secondary ? dispatch({ type: types.GET_STYLESLIST_SECONDARY_COMPLETED, payload: null }) : dispatch({ type: types.GET_STYLESLIST_COMPLETED, payload: null });
        if (pageSize < 0) {return onSuccess(null);}
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Style/OrganizationStyles/" + store().currentuser.currentorganization.id + "?"
                + "pageNumber=" + pageNumber
                + "&pageSize=" + pageSize
                + (sortExpression ? "&sortExpression=" + sortExpression : "")
                + (filterExpression ? "&filterExpression=" + filterExpression : "")
        , { method: "GET" }).then((data) => {
            data.sortExpression = sortExpression;
            data.filterExpression = filterExpression;
            data.tagSearchRequest = tagSearchRequest;
            data.PaginationType = PaginationType;
            secondary ? dispatch({ type: types.GET_STYLESLIST_SECONDARY_COMPLETED, payload: data }) : dispatch({ type: types.GET_STYLESLIST_COMPLETED, payload: data });
            return onSuccess(data);
        }).catch( (data) => {
            console.log(data);
        });
    },

    GetSecondaryStyles: (pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess) => (dispatch) => {
        dispatch(ActionsCreators.GetStyles(pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess, true));
    },

    GetStyle: (styleId, callback) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Style/" + styleId, { method: "GET" }).then((data) => {
            callback(data);
            return dispatch({ type: types.GET_STYLE_COMPLETED, payload: data });
        }).catch((data) => {
            console.log(data);
        });
    },

    CreateStyle: (object, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Style/" + store().currentuser.currentorganization.id, {
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(object),
            method: "POST"
        }).then((data) => {
            toast.success(strings.styleSaved);
            if (onSuccess) {onSuccess();}
        }).catch( (data) => {
            console.log("error", data);
        });
    },

    EditStyle: (object, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Style/" + store().currentuser.currentorganization.id, {
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(object),
            method: "PUT"
        }).then((data) => {
            toast.success(strings.styleSaved);
            if (onSuccess) { onSuccess(data);}
        }).catch((data) => {
            console.log("error", data);
        });

    },

    DeleteStyle: (Id, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Style/" + Id, { method: "DELETE" }).then((data) => {
            toast.success(strings.styleDeleted);
            return onSuccess();
        }).catch((data) => {
            console.log("error", data);
        });
    },

    DuplicateStyle: (id, name, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Style/Duplicate/" + id + (name ? "?name=" + name : ""), {
            method: "GET"
        }).then((data) => {
            toast.success(strings.contentDuplicated);
            return onSuccess(data);
        }).catch( (data) => {
            if (data.body.errorCode === "duplicate") {}
            console.log(data);
        });
    },

    ClearStyleData: () => (dispatch, store) => {
        return dispatch({ type: types.CLEAR_STYLE });
    }
};
